import isObject from 'lodash/isObject';
import DocumentService from 'aurora-composition/services/documentService';
import WorkflowService from 'aurora-composition/services/workflowService';
import OwnerService from 'aurora-composition/services/ownerService';
import SellPurchaseService from 'aurora-composition/services/sellPurchaseService';
import messages from 'aurora-translations';
import { HAPPINESS_METER_FEEDBACK_URLS } from 'aurora-utils/constants';
import * as types from './constants';

// fetch payment receipt
export const fetchPaymentReceipt = id => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await WorkflowService.fetchPaymentReceipt(id);
    const data = res?.result;
    dispatch({
      type: types.FETCH_PAYMENT_RECEIPT_SUCCESS,
      payload: { data: isObject(data) ? data : {} },
    });
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
  }
};

export const downloadPaymentReceipt = payload => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });

    const documentPdf = await DocumentService.downloadDocument(payload);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${payload?.fileName || payload?.name || 'Payment_Receipt.pdf'}`);
    link.target = '_blank';

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_PAYMENT_RECEIPT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
  }
};
export const updateFeedback = payload => async dispatch => {
  try {
    dispatch({ type: types.HAPPINESS_METER_FEEDBACK });
    await WorkflowService.updateFeedback(payload);
    dispatch({
      type: types.HAPPINESS_METER_FEEDBACK_SUCCESS,
      payload: { applicationId: payload.applicationId },
    });
  } catch (error) {
    dispatch({
      type: types.HAPPINESS_METER_FEEDBACK_ERROR,
      payload: { error },
    });
  }
};
export const postSurveyFeedback = payload => async dispatch => {
  const { ratingProvided, comment, applicationId, applicationNumber, user, applicationType } = payload;
  const { CREATE_SESSION, POST_FEEDBACK } = HAPPINESS_METER_FEEDBACK_URLS;
  dispatch({ type: types.HAPPINESS_METER_FEEDBACK });
  try {
    const data = {
      advance: false,
      embeddedData: {
        Survey_Name: 'ADGM–Happiness Meter',
        SurveyID: 'SV_0iHAhXWLRuhZbca',
        Source: 'Website',
        ServiceName: messages[applicationType].defaultmessages,
        'Customer First Name': user?.user?.firstNameEn || '',
        'Customer Last Name': user?.user?.lastNameEn || '',
        'Customer Full Name': user?.user?.customerNameEn || '',
        'Customer Email': user?.user?.emailAddress || '',
        'Customer Number': user?.user?.mobileNumber || '',
        'Application No': applicationNumber,
        DateTime: new Date().toJSON(),
        Feedback: comment,
      },
    };
    fetch(CREATE_SESSION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-token': '',
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        return response.json();
      })
      .then(resultData => {
        const { sessionId } = resultData?.result;
        if (sessionId) {
          const feedbackData = {
            advance: true,
            responses: {
              QID1: {
                [ratingProvided]: {
                  selected: true,
                },
              },
              QID8: comment,
            },
          };
          fetch(`${POST_FEEDBACK}${sessionId}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-token': '',
            },
            body: JSON.stringify(feedbackData),
          }).then(() => {
            dispatch(updateFeedback({ applicationId, happinessMeter: true }));
          });
        }
      })
      .catch(error => {
        dispatch({
          type: types.HAPPINESS_METER_FEEDBACK_ERROR,
          payload: { error: error?.message },
        });
      });
  } catch (error) {
    dispatch({
      type: types.HAPPINESS_METER_FEEDBACK_ERROR,
      payload: { error },
    });
  }
};

export const previewDocuments = payload => async dispatch => {
  try {
    dispatch({ type: types.DOCUMENT_VIEW_POPUP });
    const documentPdf = await DocumentService.downloadDocument(payload);
    dispatch({ type: types.DOCUMENT_VIEW_POPUP_SUCCESS });

    return documentPdf;
  } catch (error) {
    dispatch({ type: types.DOCUMENT_VIEW_POPUP_ERROR, payload: error });
    return error;
  }
};

export const fetchUserDetails = (eid, params) => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await OwnerService.fetchUserById(eid, params);
    dispatch({
      type: types.COMMON_ACTION_SUCCESS,
    });
    return res;
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR });
    return error;
  }
};

export const fetchCompanyDetails = tradeLicense => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await OwnerService.fetchCompanyByLicense(tradeLicense);

    dispatch({ type: types.COMMON_ACTION_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR });
    return error;
  }
};

export const fetchGovernmentCompanies = params => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await OwnerService.fetchGovernmentCompanies(params);

    dispatch({ type: types.COMMON_ACTION_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: error });
    return error;
  }
};

export const fetchPOAsList = (appId, params) => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await SellPurchaseService.fetchPOAs(appId, params);

    dispatch({ type: types.COMMON_ACTION_SUCCESS });

    return res;
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: error });
    return error;
  }
};

export const downloadDocument = payload => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });

    const documentPdf = await DocumentService.downloadDocument(payload);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${payload?.name || 'doc.pdf'}`);
    link.target = '_blank';

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);

    dispatch({ type: types.COMMON_ACTION_SUCCESS });
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
  }
};
// Entity Actions

export const fetchUAEResident = ({ eidOrUnified, params }) => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await OwnerService.fetchUserById(eidOrUnified, params);
    if (res?.result) {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          UAE_RESIDENT: res?.result
            ? [
                {
                  ...res?.result,
                  type: 'UAE_RESIDENT',
                },
              ]
            : [],
          noResults: false,
        },
      });
    } else {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          UAE_RESIDENT: [],
          noResults: true,
        },
      });
    }
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
  }
};

export const fetchNONUAEResident = params => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await OwnerService.fetchNonUAEUser(params);
    if (res?.result) {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          NON_UAE_RESIDENT: res?.result
            ? [
                {
                  ...res?.result,
                  type: 'NON_UAE_RESIDENT',
                },
              ]
            : [],
          noResults: false,
        },
      });
    } else {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          NON_UAE_RESIDENT: [],
          noResults: true,
        },
      });
    }
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
  }
};

export const fetchCompanyByLicNo = licenseNo => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await OwnerService.fetchCompanyByLicense(licenseNo);
    if (res?.result) {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          COMPANY: res?.result
            ? [
                {
                  ...res?.result,
                  type: 'COMPANY',
                },
              ]
            : [],
          noResults: false,
        },
      });
    } else {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          COMPANY: [],
          noResults: true,
        },
      });
    }
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
  }
};

export const fetchGovernment = params => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    const res = await OwnerService.fetchGOVCompanies(params);
    if (res?.result?.data?.length > 0) {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          GOVERNMENT_ENTITY: res?.result?.data.map(gov => ({
            ...gov,
            type: 'GOVERNMENT',
          })),
          totalPages: res?.result?.totalPages,
          noResults: false,
        },
      });
    } else {
      dispatch({
        type: types.FETCH_ENTITY_SUCCESS,
        payload: {
          noResults: true,
          GOVERNMENT_ENTITY: [],
        },
      });
    }
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
  }
};

export const updateUsersDatainDBTable = ({ data }) => async dispatch => {
  try {
    dispatch({ type: types.COMMON_ACTION_START });
    await OwnerService.savePartiesDetailsInDBUserTable(data);
    dispatch({
      type: types.UPDATE_USERS_DATA_IN_DB_TABLE_SUCCESS,
    });
    return true;
  } catch (error) {
    dispatch({ type: types.COMMON_ACTION_ERROR, payload: { error } });
    return false;
  }
};

export const resetFetchedDetails = () => async dispatch => {
  dispatch({ type: types.RESET_FETCHED_ENTITY_DATA });
};

export const updateEntityCustomData = payload => async dispatch => {
  dispatch({ type: types.UPDATE_ENTITY_CUSTOM_DATA, payload });
};
// eslint-disable-next-line consistent-return
export const submitEtisalatLead = data => async dispatch => {
  try {
    dispatch({ type: types.ETISALAT_SUBMIT_START });
    const res = await WorkflowService.checkEtisalatLead(data);
    dispatch({
      type: types.ETISALAT_SUBMIT_SUCCESS,
      payload: { etisalatLead: res },
    });
    return res;
  } catch (error) {
    dispatch({ type: types.ETISALAT_SUBMIT_ERROR, payload: { error } });
  }
};
